/**
 * Formats the API `weekResetsUtc` (Monday 00:00 UTC boundary) in the user's locale and timezone.
 */
export function formatExplorerLimitResetUtc(
  weekResetsUtc: string | undefined,
  locale: string
): string {
  if (!weekResetsUtc) return "";
  const date = new Date(weekResetsUtc);
  if (Number.isNaN(date.getTime())) return "";

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
    timeZoneName: "short",
  }).format(date);
}
